module.exports = __webpack_public_path__ + "static/media/4.79ec12b7.png";